import React from "react";
import { useTranslation } from "react-i18next";

export default function GoalInput({ goals, setGoals }) {
    const { t } = useTranslation();

    const handleUpdate = (index, field, value) => {
        const updated = [...goals];
        updated[index][field] = value;
        setGoals(updated);
    };

    const handleRemove = (index) => {
        setGoals(goals.filter((_, i) => i !== index));
    };

    const handleAdd = () => {
        setGoals([
            ...goals,
            {
                text: "",
                progress: [],
                currentScore: "",
                currentComment: "",
            },
        ]);
    };

    return (
        <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700 mb-1">
                {t("goal_identification")}
            </label>

            {goals.map((goal, index) => {
                const latestProgressScore = goal.progress?.[goal.progress.length - 1]?.score;
                const latestScore = goal.currentScore ?? latestProgressScore ?? 0;

                return (
                    <div key={index} className="mb-2 p-2 border rounded bg-white">
                        <input
                            type="text"
                            value={goal.text}
                            onChange={(e) => handleUpdate(index, "text", e.target.value)}
                            placeholder={t("goal_title")}
                            className="w-full border px-2 py-1 mb-2"
                        />

                        <div className="flex items-center gap-2">
                            <input
                                type="number"
                                min="0"
                                max="10"
                                value={goal.currentScore}
                                onChange={(e) => handleUpdate(index, "currentScore", e.target.value)}
                                className="w-20 border px-2 py-1"
                            />

                            <span className="text-sm text-gray-600">{t("/10 progress")}</span>

                            <input
                                type="text"
                                placeholder={t("comment_justification")}
                                value={goal.currentComment}
                                onChange={(e) => handleUpdate(index, "currentComment", e.target.value)}
                                className="w-full border px-2 py-1 mt-1"
                            />

                            <button
                                type="button"
                                onClick={() => handleRemove(index)}
                                className="text-red-500 text-sm"
                            >
                                ✕ Remove
                            </button>
                        </div>

                        {goal.progress && goal.progress.length > 1 && (
                            <ul className="text-xs text-gray-500 mt-2">
                                {goal.progress.map((entry, i) => (
                                    <li key={i}>
                                        {new Date(entry.date).toLocaleDateString()}: {entry.score}/10
                                        {entry.comment && (
                                            <span className="block text-xs text-gray-600 mt-1">
                                                💬 {entry.comment}
                                            </span>
                                        )}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                );
            })}

            <button
                type="button"
                onClick={handleAdd}
                className="mt-2 text-sm text-blue-600 underline"
            >
                + {t("goal")}
            </button>
        </div>
    );
}
